var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 52,
    viewBox: "0 0 150 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9482 27.9258H150V52H86.6884C81.3091 52 76.9482 47.6886 76.9482 42.3703V27.9258Z",
    fill: "#EEF3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9482 24.0743H150V0.000123257H86.6884C81.3091 0.000123257 76.9482 4.31148 76.9482 9.6298V24.0743Z",
    fill: "#EEF3F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000277595 0H73.0521V24.0742H9.74052C4.36113 24.0742 0.000277595 19.7628 0.000277595 14.4445V0Z",
    fill: "#EEF3F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0518 27.9258H0V52H63.3116C68.6909 52 73.0518 47.6886 73.0518 42.3703V27.9258Z",
    fill: "#EEF3F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcLogoLight);
export default __webpack_public_path__ + "static/media/JC_logo_light.1dd3f2650053b52f0a65ff52714817ad.svg";
export { ForwardRef as ReactComponent };